<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="1000px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="125px">
      <el-form-item label="赠送原因">
        <el-input v-model="displayConfigName" placeholder="赠送原因" :disabled="true" />
      </el-form-item>
      <el-form-item label="key">
        <el-input v-model="displayConfigKey" placeholder="key" :disabled="true" />
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="推送城市账套" prop="sendTo">
        <el-select v-model="form.sendTo" placeholder="请选择">
          <el-option label="杜一生" :value="1"></el-option>
          <el-option label="教育公司" :value="2"></el-option>
          <el-option label="城市公司" :value="3"></el-option>
          <el-option label="收款银行城市公司" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推送客户身份" prop="ifLevel">
        <el-select v-model="form.ifLevel" placeholder="请选择">
          <el-option label="不使用条件" :value="0"></el-option>
          <el-option label="是研修班才推送" :value="1"></el-option>
          <el-option label="不是研修班才推送" :value="2"></el-option>
          <el-option label="是体验班才推送" :value="3"></el-option>
          <el-option label="不是体验班才推送" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否区分客户杜一生" prop="ifDys">
        <el-select v-model="form.ifDys" placeholder="请选择">
          <el-option label="不使用条件" :value="0"></el-option>
          <el-option label="是杜一生客户才推送 " :value="1"></el-option>
          <el-option label="不是杜一生客户才推送" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="AB账双方城市id" >
        <el-select v-model="form.ifCityidDengyuCityid" placeholder="请选择">
          <el-option label="不使用条件" :value="0"></el-option>
          <el-option label="不等于" :value="2"></el-option>
          <el-option label="等于 " :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对向流水" prop="ifDysOther">
        <el-select v-model="form.ifDysOther" placeholder="请选择">
          <el-option label="不使用条件" :value="0"></el-option>
          <el-option label="是杜一生客户才推送 " :value="1"></el-option>
          <el-option label="不是杜一生客户才推送 " :value="2"></el-option>
        </el-select>
      </el-form-item>
      <div class="table-list mt20">
        <div class="spec-head">
          <div class="sp-col">配置</div>
          <div class="sp-col">科目编码(-1:银行科目)</div>
          <div class="sp-col">被操作的客户</div>
          <div class="sp-col">是否是负数</div>
          <div class="sp-col">是否是贷科目</div>
          <div class="sp-col">辅助项编码</div>
          <div class="sp-col">倍数</div>
          <div class="sp-col">操作</div>
        </div>
        <div class="spec-item" v-for="(item, idx) in form.giftData" :key="idx">
          <el-form-item class="sp-col" label-width="0" >
            配置{{ idx + 1 }}
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].code`" label-width="0" :rules="{required: true,message: '请输入科目编码',trigger: 'blur'}">
            <el-input v-model="item.code" placeholder="请输入科目编码" />
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].auxType`" label-width="0" :rules="{required: false,message: '请选择被操作的客户',trigger: 'change'}">
            <el-select v-model="item.auxType" placeholder="请选择" clearable>
              <el-option label="被操作的客户" :value="1"></el-option>
              <el-option label="ab账对方客户 " :value="2"></el-option>
              <el-option label="城市公司" :value="3"></el-option>
              <el-option label="ab账对方城市公司" :value="8"></el-option>
              <el-option label="教育公司" :value="4"></el-option>
              <el-option label="杜一生" :value="5"></el-option>
              <el-option label="后勤部" :value="6"></el-option>
              <el-option label="个人" :value="7"></el-option>
              <el-option label="收款银行城市公司" :value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].isFuShu`" label-width="0" :rules="{required: true,message: '请选择是否是负数',trigger: 'change'}">
            <el-select v-model="item.isFuShu" placeholder="请选择">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].isDai`" label-width="0" :rules="{required: true,message: '请选择是否是贷科目',trigger: 'change'}">
            <el-select v-model="item.isDai" placeholder="请选择">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].auxCode`" label-width="0" :rules="{required: false,message: '请输入辅助项编码',trigger: 'blur'}">
            <el-input v-model="item.auxCode" placeholder="请输入辅助项编码" />
          </el-form-item>
          <el-form-item class="sp-col" :prop="`giftData[${idx}].beishu`" label-width="0" :rules="{required: false,message: '请输入辅助项编码',trigger: 'blur'}">
            <el-input v-model="item.beishu" placeholder="请输入倍数" />
          </el-form-item>
          <div class="sp-col oper-icon">
            <i class="el-icon-minus" @click="handleDeleteItem(idx)" v-if="form.giftData.length > 1"></i>
            <i class="el-icon-plus" @click="handleAddItem" v-if="form.giftData.length < 6"></i>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import { guid } from "@/utils/index"

function initFormBean() {
  const formBean = {
    id: null,
    giftId: null,
    title: null,
    sendTo: null,
    ifLevel: null,
    ifDys: null,
    ifCityidDengyuCityid: 0,
    ifDysOther: 0,
    giftData: [{ 
      code: null, 
      auxType: 1, 
      isFuShu: 0, 
      isDai: 0, 
      auxCode: null,
      beishu: 1
    }]
  }
  return formBean
}

export default {
  props: ['rowItem'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      displayConfigName: '',
      displayConfigKey: '',
      formRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        sendTo: [{ required: true, message: '请选择推送城市账套', trigger: 'change' }],
        ifLevel: [{ required: true, message: '请选择推送客户身份', trigger: 'change' }],
        ifDys: [{ required: true, message: '请选择是否区分客户杜一生', trigger: 'change' }],
        ifCityidDengyuCityid: [{ required: true, message: '请选择AB账双方城市id', trigger: 'change' }],
        ifDysOther: [{ required: true, message: '请选择对向流水', trigger: 'change' }],
      },
      isRepSub: false,
    }
  },
  created() {
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.isRepSub = false
      this.form = initFormBean()
      // 从 rowItem 中获取赠送原因和key并显示
      if (this.rowItem) {
        this.displayConfigName = this.rowItem.configName || ''
        this.displayConfigKey = this.rowItem.configKey || ''
      } else {
        this.displayConfigName = ''
        this.displayConfigKey = ''
      }
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.resetForm()
      
      // 深拷贝原始数据，避免直接修改
      this.form = JSON.parse(JSON.stringify(row))
      
      // 处理配置数据，将configOne到configSix合并到giftData
      let giftDataArray = []
      const configFields = ['configOne', 'configTwo', 'configThree', 'configFour', 'configFive', 'configSix']
      
      configFields.forEach(field => {
        if (row[field]) {
          try {
            // 尝试解析JSON字符串
            const config = typeof row[field] === 'string' ? JSON.parse(row[field]) : row[field]
            if (config && Object.keys(config).length > 0) {
              giftDataArray.push({
                code: config.code || null,
                auxType: config.auxType || null,
                isFuShu: config.isFuShu !== undefined && config.isFuShu !== null ? config.isFuShu : 0,
                isDai: config.isDai !== undefined && config.isDai !== null ? config.isDai : 0,
                auxCode: config.auxCode || null,
                beishu: config.beishu || 1
              })
            }
          } catch (error) {
            console.warn(`解析配置字段 ${field} 失败:`, error)
          }
        }
      })
      
      // 如果没有数据，至少保留一个空行
      if (giftDataArray.length === 0) {
        giftDataArray = [{ 
          code: null, 
          auxType: null, 
          isFuShu: 0, 
          isDai: 0, 
          auxCode: null,
          beishu: 1
        }]
      }
      
      // 使用 this.$set 确保响应式
      this.$set(this.form, 'giftData', giftDataArray)
      
      // 从 rowItem 中获取赠送原因和key并显示（编辑时也显示）
      if (this.rowItem) {
        this.displayConfigName = this.rowItem.configName || ''
        this.displayConfigKey = this.rowItem.configKey || ''
      }
      
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 添加配置项
     */
    handleAddItem() {
      if (this.form.giftData.length < 6) {
        this.form.giftData.push({
          code: null,
          auxType: null,
          isFuShu: 0,
          isDai: 0,
          auxCode: null,
          beishu: 1
        })
      }
    },
    /**
     * 删除配置项
     */
    handleDeleteItem(idx) {
      if (this.form.giftData.length > 1) {
        this.form.giftData.splice(idx, 1)
      }
    },
    /**
     * 计算提交参数
     */
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.giftId = this.rowItem.id;
      // 将giftData转换为configOne到configSix
      params.configOne = params.giftData[0] ? JSON.stringify(params.giftData[0]) : ''
      params.configTwo = params.giftData[1] ? JSON.stringify(params.giftData[1]) : ''
      params.configThree = params.giftData[2] ? JSON.stringify(params.giftData[2]) : ''
      params.configFour = params.giftData[3] ? JSON.stringify(params.giftData[3]) : ''
      params.configFive = params.giftData[4] ? JSON.stringify(params.giftData[4]) : ''
      params.configSix = params.giftData[5] ? JSON.stringify(params.giftData[5]) : ''
      
      delete params.giftData
      return params
    },
    /**
     * 执行新建/编辑操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          let params = this.calcParams()
          if (this.form.id) {
            // 编辑操作
            sysGiftAccountReasonApi.updateReasonPz(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
              this.$message.error('操作失败')
            });
          } else {
            // 新增操作
            sysGiftAccountReasonApi.saveReasonPz(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
              this.$message.error('操作失败')
            });
          }
        }
      });
    },
    /**
     * 操作成功回调
     */
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}
.table-list {
  border: 1px solid #e4e4e4;
  // margin: 0 35px 20px 50px;
  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.oper-icon {
  i {
    cursor: pointer;
    font-size: 22px;
    color: #465c99;
    &:nth-child(1) {
      padding-right: 5px;
    }
  }
}
</style>
